import { render, staticRenderFns } from "./userModal.vue?vue&type=template&id=4fe5e970"
import script from "./userModal.vue?vue&type=script&lang=js"
export * from "./userModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports